import React from 'react';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';


const useFetchFlowDataTypeOptions = ({
  orgId, crId, crFlowId, isPartnerAssignedDatasets, enabled = true,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = React.useState();

  const {
    isLoading, isError, isSuccess,
  } = useQuery(
    ['Flow Data Type Options', crId, orgId, crFlowId, String(isPartnerAssignedDatasets)],
    async () => (
      axiosInstance.get(
        flow(orgId).dataTypeOptions(crId, crFlowId, isPartnerAssignedDatasets),
      )
    ),
    {
      onSuccess: (res) => setData(res.data.dataTypes),
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      retry: false,
      enabled: Boolean(orgId && crId && crFlowId && enabled),
    },
  );

  return {
    isLoading, isError, isSuccess, data,
  };
};

export default useFetchFlowDataTypeOptions;
